import Home from "../views/home/index.vue";

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/index",
    component: () => import("@/views/layout/index.vue"),
    redirect: "/index/download",
    children: [
      {
        path: "download",
        name: "indexdownload",
        component: () => import("@/views/index/download.vue"),
      },
      {
        path: "buy",
        name: "indexbuy",
        component: () => import("@/views/index/buy/index.vue"),
      },
      {
        path: "help",
        name: "indexhelp",
        component: () => import("@/views/index/help/index.vue"),
      },
      {
        path: "login",
        name: "indexlogin",
        component: () => import("@/views/index/login.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];
